import { useState, useEffect } from 'react';
import API_CONFIG from '../../../apiConfig';
import { ModelTemplate, BackgroundPreset, PosePreset } from '../types';

export const useWorkflowData = () => {
    const [models, setModels] = useState<ModelTemplate[]>([]);
    const [modelsLoading, setModelsLoading] = useState(false);
    const [posePresets, setPosePresets] = useState<PosePreset[]>([]);
    const [posesLoading, setPosesLoading] = useState(false);
    const [allBackgrounds, setAllBackgrounds] = useState<BackgroundPreset[]>([]);
    const [backgroundsLoading, setBackgroundsLoading] = useState(false);

    useEffect(() => {
        const fetchModels = async () => {
            try {
                setModelsLoading(true);
                const res = await fetch(API_CONFIG.GET_TRYON_MODELS_URL);
                if (!res.ok) throw new Error('Failed to fetch models');
                const data = await res.json();
                if (data.success && data.models?.length) {
                    const sorted = data.models
                        .map((item: any) => ({
                            id: item.modelId || item.id,
                            name: item.modelName || `${item.type} ${item.gender}`,
                            imageUrl: Array.isArray(item.imageUrl) ? item.imageUrl[0] : item.imageUrl || '',
                            category: item.type || 'General',
                            gender: (item.gender || 'female').toLowerCase(),
                        }))
                        .sort((a: ModelTemplate, b: ModelTemplate) => a.name.localeCompare(b.name));
                    setModels(sorted);
                }
            } catch (e) {
                console.error('Error fetching models:', e);
            } finally {
                setModelsLoading(false);
            }
        };

        const fetchPoses = async () => {
            try {
                setPosesLoading(true);
                const res = await fetch(API_CONFIG.GET_POSE_PRESETS_URL);
                if (!res.ok) throw new Error('Failed to fetch poses');
                const data = await res.json();
                if (data.success && Array.isArray(data.poses)) {
                    setPosePresets(data.poses.filter((p: PosePreset) => p.liveStatus !== false));
                }
            } catch (e) {
                console.error('Error fetching poses:', e);
            } finally {
                setPosesLoading(false);
            }
        };

        const fetchBackgrounds = async () => {
            try {
                setBackgroundsLoading(true);
                const res = await fetch(API_CONFIG.GET_BACKGROUND_PRESETS_URL);
                if (!res.ok) throw new Error('Failed to fetch backgrounds');
                const data = await res.json();
                if (data.success && Array.isArray(data.backgrounds)) {
                    setAllBackgrounds(data.backgrounds.filter((bg: BackgroundPreset) => bg.liveStatus === true));
                }
            } catch (e) {
                console.error('Error fetching backgrounds:', e);
            } finally {
                setBackgroundsLoading(false);
            }
        };

        fetchModels();
        fetchPoses();
        fetchBackgrounds();
    }, []);

    return {
        models,
        modelsLoading,
        posePresets,
        posesLoading,
        allBackgrounds,
        backgroundsLoading,
    };
};
